export const TEXTS_SEGURIDAD_DETAIL =
{
  es_ES: new Map([
      ['download', 'Descargar'],
      ['reset', 'Restablecer'],
      ['intervenciones', 'intervenciones'],
      ['h1_intervenciones', 'INTERVENCIONES'],
      ['intervenciones_totales', 'INTERVENCIONES TOTALES'],
      ['evolucion_mensual', 'EVOLUCIÓN MENSUAL'],
      ['franja_horaria', 'POR FRANJA HORARIA'],
      ['tipologia_nivel_1', 'TIPOLOGÍA NIVEL 1'],
      ['tipologia_nivel_2', 'TIPOLOGÍA NIVEL 2'],
      ['tipologia_nivel_3', 'TIPOLOGÍA NIVEL 3'],
      ['fecha', 'Fecha'],
      ['distrito', 'Distrito'],
      ['barrio', 'Barrio'],
      ['num_intervenciones', 'Num. Intervenciones'],
  ]),
  ca_ES: new Map([
      ['download', 'Desar'],
      ['reset', 'Restablir'],
      ['intervenciones', 'intervencions'],
      ['h1_intervenciones', 'INTERVENCIONS'],
      ['intervenciones_totales', 'INTERVENCIONS TOTALS'],
      ['evolucion_mensual', 'EVOLUCIÓ MENSUAL'],
      ['franja_horaria', 'POR FRANJA HORARIA'],
      ['tipologia_nivel_1', 'TIPOLOGIA NIVELL 1'],
      ['tipologia_nivel_2', 'TIPOLOGIA NIVELL 2'],
      ['tipologia_nivel_3', 'TIPOLOGIA NIVELL 3'],
      ['fecha', 'Data'],
      ['distrito', 'Districte'],
      ['barrio', 'Barri'],
      ['num_intervenciones', 'Nombre Intervencions'],
  ]),
}
